import { render, staticRenderFns } from "./myFile.vue?vue&type=template&id=3273c54e&scoped=true"
import script from "./myFile.vue?vue&type=script&lang=js"
export * from "./myFile.vue?vue&type=script&lang=js"
import style0 from "./myFile.vue?vue&type=style&index=0&id=3273c54e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3273c54e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3273c54e')) {
      api.createRecord('3273c54e', component.options)
    } else {
      api.reload('3273c54e', component.options)
    }
    module.hot.accept("./myFile.vue?vue&type=template&id=3273c54e&scoped=true", function () {
      api.rerender('3273c54e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/cloudfile/components/myFile.vue"
export default component.exports